import { Button, Dropdown, MenuProps } from 'antd';
import React from 'react';
import { Link, Icon } from '@common/components';

import { MissionControlComplianceAssignment } from '@working-experience/graphql';

type ComplianceActionsType = Pick<MissionControlComplianceAssignment, 'id'>;

const generateMenuItems = (
  assignment: ComplianceActionsType
): MenuProps['items'] => {
  const { id } = assignment;

  return [
    {
      key: '1',
      style: { width: '180px' },
      label: (
        <Link to={`/works/team/long_term/${id}/profile`} target="_blank">
          View Profile{' '}
          <Icon
            className="wk-external-link__icon"
            icon="arrowUpRightFromSquare"
            size="sm"
          />
        </Link>
      ),
    },
  ];
};

export const ComplianceActionsDropdown = ({
  assignment,
}: {
  assignment: ComplianceActionsType;
}) => {
  const menuItems = assignment ? generateMenuItems(assignment) : [];

  return (
    <Dropdown
      className="compliance-actions-dropdown"
      menu={{
        items: menuItems,
      }}
      trigger={['click']}
    >
      <Button
        type="link"
        shape="circle"
        color="elm"
        style={{ padding: 5 }}
        icon={
          <Icon size="lg" icon="verticalEllipsis" kind="regular" color="elm" />
        }
      />
    </Dropdown>
  );
};
